import { CATEGORY_TONES, STATUS_TONES } from "@/components/ui/tone-classes"
export const formatTimestamp = (isoString: string): string => {
  try {
    const date = new Date(isoString)
    return new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(date)
  } catch {
    return isoString
  }
}

export const getActionColor = (action: string): string => {
  if (action.includes("status")) return STATUS_TONES.info.solid
  if (action.includes("access")) return CATEGORY_TONES[1]
  if (action.includes("config")) return "bg-warning/30 text-warning-ink "
  if (action.includes("create")) return STATUS_TONES.success.solid
  if (action.includes("delete")) return STATUS_TONES.destructive.solid
  return "bg-muted text-muted-foreground border border-border"
}

export const formatActionLabel = (action: string): string => {
  return action
    .split(".")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" → ")
}

export const getValueColor = (value: unknown): string => {
  if (typeof value === "boolean") {
    return value ? STATUS_TONES.success.text : STATUS_TONES.destructive.text
  }
  return "text-foreground"
}
